var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{staticStyle:{"border":"none"}}),_vm._v(" "),(_vm.isRouterAlive)?_c('div',{staticStyle:{"overflow":"hidden"},attrs:{"id":"content"}},[_c('router-view')],1):_vm._e(),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }